import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="bg-[#0A101D] border-t border-border mt-auto">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    {/* Brand */}
                    <div className="col-span-1 md:col-span-2">
                        <div className="flex items-center gap-2 mb-4">
                            <span className="text-2xl font-bold text-primary">G-Store</span>
                            <span className="text-sm text-white tracking-widest">Assistenza e Riparazione</span>
                        </div>
                        <p className="text-muted mb-4 max-w-md">
                            Il tuo centro di fiducia per riparazioni professionali di smartphone, tablet, computer e console gaming. 
                            Dispositivi ricondizionati di qualità con garanzia.
                        </p>
                        <div className="flex flex-col gap-2 text-muted">
                            <div className="flex items-center gap-2">
                                <Phone className="w-4 h-4 text-primary" />
                                <a href="tel:0819228487" className="hover:text-primary transition-colors">081 922 8487</a>
                            </div>
                            <div className="flex items-center gap-2">
                                <Mail className="w-4 h-4 text-primary" />
                                <a href="mailto:infoclientigstore@gmail.com" className="hover:text-primary transition-colors">infoclientigstore@gmail.com</a>
                            </div>
                            <div className="flex items-center gap-2">
                                <MapPin className="w-4 h-4 text-primary" />
                                <span>Via Giuseppe Atzori 44/6, Nocera Inferiore</span>
                            </div>
                            <div className="flex items-start gap-2">
                                <Clock className="w-4 h-4 text-primary mt-1" />
                                <div>
                                    <p>Lun-Ven: 09:00-13:00 / 16:00-19:30</p>
                                    <p>Sabato: 09:30-13:00</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="font-semibold text-white mb-4">Link Rapidi</h4>
                        <ul className="space-y-2 text-muted">
                            <li>
                                <Link to="/store" className="hover:text-primary transition-colors">Store</Link>
                            </li>
                            <li>
                                <Link to="/riparazioni" className="hover:text-primary transition-colors">Riparazioni</Link>
                            </li>
                            <li>
                                <Link to="/listino" className="hover:text-primary transition-colors">Listino Prezzi</Link>
                            </li>
                            <li>
                                <Link to="/prenota" className="hover:text-primary transition-colors">Prenota</Link>
                            </li>
                        </ul>
                    </div>

                    {/* Services */}
                    <div>
                        <h4 className="font-semibold text-white mb-4">Servizi</h4>
                        <ul className="space-y-2 text-muted">
                            <li>Riparazione Smartphone</li>
                            <li>Riparazione Tablet</li>
                            <li>Assistenza Computer</li>
                            <li>Riparazione Console</li>
                            <li>Vendita Ricondizionati</li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-border mt-8 pt-8 text-center text-muted text-sm">
                    <p>&copy; {new Date().getFullYear()} G-Store Assistenza e Riparazione. Tutti i diritti riservati.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
